import { FC } from 'react';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import Tink from './Tink';
import useClientQuery from 'ui/hooks/useClientQuery';
import useLoanApplicationQuery from 'ui/hooks/useLoanApplicationQuery';

const TinkScene: FC = () => {
  const { data, status } = useClientQuery(true);
  const loanApplication = useLoanApplicationQuery();

  if (
    status === 'loading' ||
    !data ||
    loanApplication.status !== 'success' ||
    !loanApplication.loanApplication
  )
    return (
      <LoanApplicationProcessLayout>
        <div />
      </LoanApplicationProcessLayout>
    );

  const personalId = data.personalId;
  const loanApplicationId = loanApplication.loanApplication.id;

  return (
    <LoanApplicationProcessLayout>
      <Tink personalId={personalId} loanApplicationId={loanApplicationId} />
    </LoanApplicationProcessLayout>
  );
};

export default TinkScene;
